import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { PartnerQuotaEditDialogHeader } from "./PartnerQuotaEditDialogHeader";
import { PartnerQuotaEditForm } from "./PartnerQuotaEditForm.jsx";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/partner-quota-action";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import { useHistory, useParams } from "react-router-dom";
import { initialValue } from "../PartnerQuotaUIHelpers";
import { Card } from "../../../../../_metronic/_partials/controls";

export const PartnerQuotaEditDialog = () => {
  const {id} = useParams()
  const history = useHistory()

  // PartnerQuota Redux state
  const dispatch = useDispatch();
  const { actionsLoading, initialFormValue, error, roleMaster } = useSelector(
    (state) => ({
      actionsLoading: state.partnerQuota.actionsLoading,
      initialFormValue: state.partnerQuota.initialFormValue,
      roleMaster: state.partnerQuota.roleMaster,
      error: state.partnerQuota.error,
    }),
    shallowEqual
  );

  useEffect(() => {
    return () => {
      dispatch(actions.resetInitialFormValue())
    }
  }, [])

  if (error) {
    toast.error(error, toastOption);
  }

  const savePartnerQuota = (partnerQuota) => {
      dispatch(actions.createPartnerQuota(partnerQuota)).then((response) => {
        if (response) toast.success(response.message, toastOption);
        history.push("/kurban/quota-partner")
      });
  };

  return (
    <Card>
      <PartnerQuotaEditDialogHeader id={id} />
      <PartnerQuotaEditForm
        savePartnerQuota={savePartnerQuota}
        actionsLoading={actionsLoading}
        partnerQuota={initialFormValue || initialValue}
        roleMaster={roleMaster}
        id={id}
      />
    </Card>
  );
};
